import { Plugin } from '@ckeditor/ckeditor5-core';
import type { ViewDocumentFragment } from '@ckeditor/ckeditor5-engine';
import { ClipboardPipeline } from '@ckeditor/ckeditor5-clipboard';
// What ClipboardPipeline applies to pasted HTML; not exported by the package index.
import normalizeClipboardHtml from '@ckeditor/ckeditor5-clipboard/src/utils/normalizeclipboarddata.js';
import { ClipboardOutputEmitter, PasteGuardConfig, registerOwnContentMarker, registerPasteGuard } from './handler';

export default class PasteGuard extends Plugin {
    public static get pluginName() {
        return 'PasteGuard' as const;
    }

    public static get requires() {
        return [ClipboardPipeline];
    }

    public init(): void {
        const editor = this.editor;
        const config = (editor.config.get('pasteGuard') as PasteGuardConfig | undefined) ?? {};
        const clipboard = editor.plugins.get('ClipboardPipeline') as ClipboardPipeline;

        // ClipboardPipeline builds data.content with the HTML processor; use the
        // same one. The default data processor is GFM here because the build
        // loads Markdown, and serialising through it yields text without tags.
        registerPasteGuard(clipboard, editor.data.htmlProcessor, config);

        // ClipboardPipeline fires clipboardOutput for copy, cut and dragstart.
        if (config.mode !== 'off') {
            registerOwnContentMarker(
                editor.editing.view.document as unknown as ClipboardOutputEmitter<ViewDocumentFragment>,
                editor.data.htmlProcessor,
                normalizeClipboardHtml,
                config
            );
        }
    }
}
